import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { OtpGenerateReq, OtpGenerateRes, OtpLoginRes, OtpValidateData, OtpValidateRes } from './otp.model';

@Injectable({
  providedIn: 'root'
})
export class OtpService {
  constructor(private http: HttpClient) {}

  getMobileNo(identityNo: string): Observable<OtpLoginRes> {
    const url = environment.endpoint.otpUrl;

    return this.http.post<OtpLoginRes>(url, { identityNo }).pipe();
  }

  generateOtp(requestId: string, language: string, otpReferenceId?: string): Observable<OtpGenerateRes> {
    const url = environment.endpoint.otpUrl;

    const req: OtpGenerateReq = {
      requestId,
      ...otpReferenceId && { otpReferenceId },
      language,
    };

    return this.http.post<OtpGenerateRes>(url, req).pipe();
  }

  validateOtp(otpData: OtpValidateData): Observable<OtpValidateRes> {
    const url = environment.endpoint.otpUrl;

    return this.http.post<OtpValidateRes>(url, otpData).pipe();
  }
}
